import termsDeposit from './reducers/terms'

export default termsDeposit



// WEBPACK FOOTER //
// ./src/sections/termsDeposit/reducer.js